module.exports = __webpack_public_path__ + "static/media/guiter.b79cddae.avif";